'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _web3Utils = require('web3-utils');

var _PropTypeBn = require('../utilities/PropTypeBn');

var _tokenUtilities = require('../utilities/tokenUtilities');

var _constants = require('../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Displays a token amount as "[formatted amount] [symbol]", or "0" if invalid input.
 */
var FormattedTokenWei = function FormattedTokenWei(_ref) {
  var tokenList = _ref.tokenList,
      amount = _ref.amount,
      tokenAddress = _ref.tokenAddress,
      decimals = _ref.decimals,
      showSymbol = _ref.showSymbol;

  // Attempt to format only if there is valid inputs.
  if (_web3Utils.BN.isBN(amount) && (0, _tokenUtilities.findTokenByAddress)(tokenList, tokenAddress)) {
    var tokenDecimals = (0, _tokenUtilities.getTokenDecimals)(tokenList, tokenAddress);
    var tokenSymbol = showSymbol ? (0, _tokenUtilities.getTokenSymbol)(tokenList, tokenAddress) : '';
    var roundedEth = (0, _tokenUtilities.formatTokenWei)(amount, tokenDecimals, tokenSymbol, decimals);
    var fullEth = (0, _tokenUtilities.formatTokenWei)(amount, tokenDecimals, tokenSymbol, tokenDecimals);
    return roundedEth === fullEth ? _react2.default.createElement(
      'span',
      null,
      fullEth
    ) : _react2.default.createElement(
      'span',
      { title: fullEth },
      roundedEth
    );
  }
  return _react2.default.createElement(
    'span',
    null,
    '0'
  );
};

FormattedTokenWei.displayName = 'FormatTokenWei';

FormattedTokenWei.defaultProps = {
  decimals: _constants.DEFAULT_ETH_DECIMALS,
  showSymbol: true
};

_PropTypeBn.PropTypeBn.isRequired = _PropTypeBn.PropTypeBnIsRequired;
FormattedTokenWei.propTypes = {
  tokenList: _propTypes2.default.arrayOf(_propTypes2.default.shape({})).isRequired,
  amount: _PropTypeBn.PropTypeBn.isRequired,
  tokenAddress: _propTypes2.default.string.isRequired,
  decimals: _propTypes2.default.number,
  showSymbol: _propTypes2.default.bool
};

exports.default = FormattedTokenWei;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@blockcatio/tabby-library/lib/components/FormattedTokenWei.js
// module id = 473
// module chunks = 0